export const SetUpUrl = 'setups-new';
